import {Trans} from '@lingui/macro';
import React from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonGroupSpacer} from '../../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroupSpacer';
import {ContactSalesButton} from '../../../../components/common/callToAction/contactSalesButton';
import {Dialog} from '../../../../components/common/dialogs/dialog';
import {DialogButtonGroup} from '../../../../components/common/dialogs/dialogButtonGroup';
import {DialogContent} from '../../../../components/common/dialogs/dialogContent';
import {DialogHeader} from '../../../../components/common/dialogs/dialogHeader';

/*
 * Type.
 */

interface UnauthorizedAdvancedRuleDialogProps {
  onCancel: Handler;
}

/*
 * Component.
 */

export const UnauthorizedAdvancedRuleDialog = ({onCancel}: UnauthorizedAdvancedRuleDialogProps) => (
  <Dialog onRequestClose={onCancel}>
    <DialogHeader title={<Trans id="advanced-rules-required-dialog-title">Advanced Rules Required</Trans>} />
    <DialogContent>
      <Trans id="advanced-rules-required-dialog-body">
        This is an advanced rule, but your plan only includes basic rules.
      </Trans>
    </DialogContent>
    <DialogButtonGroup>
      <ButtonGroupSpacer />
      <Button onClick={onCancel}>
        <Trans id="advanced-rules-required-dialog-cancel">Cancel</Trans>
      </Button>
      <ContactSalesButton />
    </DialogButtonGroup>
  </Dialog>
);
